import React from "react"

import {INSERT_HORIZONTAL_RULE_COMMAND} from "@lexical/react/LexicalHorizontalRuleNode"
import {INSERT_IMAGE_COMMAND} from "../../../image"
import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"
import {INSERT_PAGE_BREAK} from "../../../page-break"
import PopoverMenuOptionWithSubmenu from "../../../../../popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import {lexicalInsertEmojiTrigger} from "../../../../actions/insert-emoji-trigger"
import {INSERT_TABLE_COMMAND} from "@lexical/table"
import {INSERT_LAYOUT_COMMAND} from "../../../layout"
import {INSERT_COLLAPSIBLE_COMMAND} from "../../../collapse-container"
import {INSERT_YOUTUBE_COMMAND} from "../../../embed/youtube"
import {FigmaEmbedConfig, YoutubeEmbedConfig} from "../../../embed"
import {INSERT_FIGMA_COMMAND} from "../../../embed/figma"

const debug = false
// const debug = "ToolbarInsertMenu"

export default function ToolbarInsertMenu(props:any) {

    const onClickHorizontalRule = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND, undefined)
    }

    const onClickPageBreak = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(INSERT_PAGE_BREAK, undefined)
    }

    const onClickImage = () => {
        props.hidePopover()

        gd.modals.oneInput('Image src', '', 'Add image', (src:string)=>{
            gd.modal.hide()

            /*gd.utils.getImageDimensions(src, (width:number, height:number)=>{
                const aspectRatio = height/width
                props.menuParams.editor.dispatchCommand(INSERT_IMAGE_COMMAND, {src, aspectRatio})
            }, (e:any)=>{
                console.error('Image src: error', e)
            })*/

            props.menuParams.editor.dispatchCommand(INSERT_IMAGE_COMMAND, {src})
        })
    }

    const onClickContentTable = () => {
        props.hidePopover()
    }

    const onClickEmoji = () => {
        props.hidePopover()
        lexicalInsertEmojiTrigger(props.menuParams.editor)
    }

    const onClickTable = () => {
        props.hidePopover()

        gd.modals.richEditor.tableSize(({rows,columns}:{rows:number, columns:number})=>{
            props.menuParams.editor.dispatchCommand(INSERT_TABLE_COMMAND, {
                rows            : String(rows),
                columns         : String(columns),
                includeHeaders  : true
            })
        })
    }

    const onClickColumnLayout = () => {
        props.hidePopover()

        gd.modals.richEditor.columnsLayout(({layoutType}:{layoutType:string})=>{
            props.menuParams.editor.dispatchCommand(INSERT_LAYOUT_COMMAND, layoutType)
        })
    }

    const onClickCollapseContainer = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(INSERT_COLLAPSIBLE_COMMAND, undefined)
    }

    const onClickEmbed = (value:any) => {
        props.hidePopover()

        switch (value) {
            case 'youtube'  :
                gd.modals.oneInput('Video source', 'https://www.youtube.com/watch?v=', 'Embed Youtube Video', async (url:string)=>{
                    gd.modal.hide()
                    const videoData:any = await YoutubeEmbedConfig.parseUrl(url)

                    debug && console.log(debug, 'onClickEmbed', value, url, videoData)

                    if (videoData) props.menuParams.editor.dispatchCommand(INSERT_YOUTUBE_COMMAND, videoData.id)
                })
                break

            case 'figma'    :
                gd.modals.oneInput('Figma source', 'https://www.figma.com/file/', 'Embed Figma Document', (url:string)=>{
                    gd.modal.hide()
                    const figmaData:any = FigmaEmbedConfig.parseUrl(url)

                    debug && console.log(debug, 'onClickEmbed', value, url, figmaData)

                    if (figmaData) props.menuParams.editor.dispatchCommand(INSERT_FIGMA_COMMAND, figmaData.id)
                })
                break
        }
    }

    return (
        <div className="ui5-popover-menu icon-fs-16 with-help" style={{width:180}}>
            <PopoverMenuOption option   = {{icon: 'editor-i5-line', label: 'Horizontal line'}}
                               onClick  = {onClickHorizontalRule}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-image', label: 'Image'}}
                               onClick  = {onClickImage}/>

            {/*<PopoverMenuOption option   = {{icon: 'editor-i5-content-table', label: 'Table of content'}}
                               onClick  = {onClickContentTable}/>*/}

            <PopoverMenuOption option   = {{icon: 'editor-i5-emoji', label: 'Emoji'}}
                               onClick  = {onClickEmoji}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-table', label: 'Table'}}
                               onClick  = {onClickTable}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-column-layout', label: 'Column layout'}}
                               onClick  = {onClickColumnLayout}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-collapse-cont', label: 'Collapse container'}}
                               onClick  = {onClickCollapseContainer}/>

            <PopoverMenuOptionWithSubmenu menuClassName     = 'icon-fs-16'
                                          option            = {{
                                              icon    : 'editor-i5-embed',
                                              label   : 'Embed',
                                              options : [
                                                  {value: 'youtube',    icon: 'editor-i5-youtube',  label: 'Youtube video'},
                                                  {value: 'figma',      icon: 'editor-i5-figma',    label: 'Figma document'},
                                              ]
                                          }}
                                          selectedValue     = {props.menuParams.blockType}
                                          showMenuSelection = {true}
                                          onClick           = {onClickEmbed}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-page-break', label: 'Page break'}}
                               onClick  = {onClickPageBreak}/>
        </div>
    )
}